class TranslationCountries {
	
	/**
	 * translation of the country names based on the selected language by user for the list in Tomselect
	 */
	static translationCountryNames() {
		const userChosenLanguage = document.getElementById('dropdownlanguageMenu');
		const languageSelected = userChosenLanguage.getAttribute('data-language-selected');
		return new Intl.DisplayNames([languageSelected.replace('_', '-').toLowerCase()], {type: 'region'});
	}
}

module.exports = TranslationCountries;